export enum PermissionErrors {
  SITE_HIDDEN = 'SITE_HIDDEN',
  CONTRACT_DIFFERENT = 'CONTRACT_DIFFERENT',
}
